import { connect } from 'react-redux';

import ResetPasswordView from '../components/ResetPasswordView';

const mapActionCreators = {};
const mapStateToProps = state => ({});

export default connect(
    mapStateToProps,
    mapActionCreators
)(ResetPasswordView);
